import memoizee from "memoizee";
import MobileDetect from "mobile-detect";
import {useEffect, useState} from "react";

/**
 * Checks is the user agent is a mobile device.
 */
const checkUserAgent = (userAgent: string): boolean => {
  const md = new MobileDetect(userAgent);
  return !!md.mobile() || !!md.tablet();
};

/**
 * Generally testing user agent strings like this for a particular browser is unreliable.
 * Use with caution.
 */
export const useIsFirefox = () => {
  const [state, setState] = useState<boolean | undefined>();

  useEffect(() => {
    const md = new MobileDetect(window.navigator.userAgent);
    setState(md.userAgent() === "Firefox");
  }, []);

  return state;
};

/**
 * Memoized to prevent unnecessary string parsing.
 */
const getIsMobileClient = memoizee(() => {
  return checkUserAgent(window.navigator.userAgent);
});

export const useIsMobile = () => {
  const [state, setState] = useState<boolean | undefined>();

  useEffect(() => {
    setState(getIsMobileClient());
  }, []);

  return state;
};
